module.exports = "<p>\r\n  Downloading...\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar-event-files/calendar-event-files.component.html
// module id = ./src/app/calendar-event-files/calendar-event-files.component.html
// module chunks = main